import React, { useState } from 'react';
import {
  Box,
  useBreakpointValue,
  VStack,
  Heading,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  IconButton,
} from '@chakra-ui/react';
import { FaSpotify, FaApple, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import TrackForm from './TrackForm';

const AddTrack = () => {
  const tabSize = useBreakpointValue({ base: 'sm', md: 'md' });
  const navigate = useNavigate();
  const [, setSelectedTab] = useState(0);

  // Lifted state for TrackForm inputs
  const [id, setId] = useState('');
  const [appleStorefront, setAppleStorefront] = useState('us');

  return (
    <Box display="flex" justifyContent="center" alignItems="center" pb={{ base: '12rem', md: 0 }}>
      <Box
        borderRadius="lg"
        p={6}
        w="100%"
        maxW="450px"
        boxShadow="2xl"
        border="1px solid"
        borderColor="rgba(255,255,255,0.1)"
      >
        {/* Heading + Back Button */}
        <Box position="relative" mb={6}>
        <IconButton
            aria-label="Go back"
            icon={<FaArrowLeft />}
            variant="ghost"
            position="absolute"
            top="50%"
            left={-3}
            transform="translateY(-50%)"
            onClick={() => navigate('/dashboard/artist/tracks')}
          />
          <Heading
            as="h2"
            fontSize={{ base: 'lg', md: 'xl' }}
            textAlign="center"
            mb={6}
            color="primary.500"
          >
            Add a Track
          </Heading>
          
        </Box>

        <Tabs onChange={setSelectedTab} size={tabSize} isFitted>
          <TabList mb={4} p={0} bg="transparent" border="none">
            <Tab
              _selected={{
                bg: 'dark.100',
                color: 'dark.900',
                fontWeight: 'bold',
                border: '1px solid',
                borderColor: 'dark.900',
                boxShadow: 'none',
              }}
              _focus={{ boxShadow: 'none' }}
              _hover={{ bg: 'dark.500', color: 'dark.900' }}
              color="primary.100"
              bg="secondary.100"
              borderRadius="sm"
              px={2}
              py={2}
              mx={0}
            >
              <Box as={FaSpotify} mr={2} display="inline-block" />
              Spotify
            </Tab>
            <Tab
              _selected={{
                bg: 'dark.100',
                color: 'dark.900',
                fontWeight: 'bold',
                border: '1px solid',
                borderColor: 'dark.900',
                boxShadow: 'none',
              }}
              _focus={{ boxShadow: 'none' }}
              _hover={{ bg: 'dark.500', color: 'dark.900' }}
              color="primary.100"
              bg="secondary.100"
              borderRadius="sm"
              px={2}
              py={2}
              mx={0}
            >
              <Box as={FaApple} mr={2} display="inline-block" />
              Apple
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <VStack spacing={4} align="stretch">
                <TrackForm service="spotify" id={id} setId={setId} />
              </VStack>
            </TabPanel>

            <TabPanel>
              <VStack spacing={4} align="stretch">
                <TrackForm
                  service="apple"
                  id={id}
                  setId={setId}
                  storefront={appleStorefront}
                  setStorefront={setAppleStorefront}
                />
              </VStack>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
};

export default AddTrack;
